import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { getRelatedArticles } from '../data/articles';
import { ArticleCard } from './ArticleCard';
interface RelatedArticlesProps {
  currentSlug: string;
  relatedSlugs: string[];
}
export function RelatedArticles({
  currentSlug,
  relatedSlugs
}: RelatedArticlesProps) {
  const related = getRelatedArticles(currentSlug, relatedSlugs);
  if (related.length === 0) return null;
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const cardVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: 'easeOut'
      }
    }
  };
  return <section className="py-16" data-id="element-212">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-213">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-vita-green-deep mb-10 text-center" data-id="element-214">
          Das könnte dich auch interessieren
        </h2>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-5xl mx-auto" data-id="element-215">
          {related.slice(0, 3).map((article, index) => <motion.div key={article.slug} variants={cardVariants} data-id="element-216">
              <ArticleCard article={article} index={index} data-id="element-217" />
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}